import { createSlice } from '@reduxjs/toolkit';

export const name = 'confirm';

const confirmSlice = createSlice({
  name,
  initialState: {
    show: false,
    header: null,
    body: null,
    message: null,
    variant: null,
    okValue: null,
    cancelButton: true,
    cancelValue: null,
    onConfirm: null,
    rootClose: true,
    loading: false
  },
  reducers: {
    showConfirm: (state, action) => {
      const {
        header,
        body,
        message,
        variant,
        okValue,
        cancelButton,
        cancelValue,
        onConfirm,
        rootClose
      } = action.payload;

      state.header = header;
      state.body = body || null;
      state.message = message || null;
      state.variant = variant;
      state.okValue = okValue;

      if (cancelButton === false) {
        state.cancelButton = false;
      } else {
        state.cancelButton = true;
      }

      if (rootClose === false) {
        state.rootClose = false;
      }

      state.cancelValue = cancelValue;
      state.onConfirm = onConfirm;
      state.show = true;
    },
    closeConfirm: (state) => {
      state.header = null;
      state.body = null;
      state.message = null;
      state.variant = null;
      state.okValue = null;
      state.cancelButton = true;
      state.cancelValue = null;
      state.onConfirm = null;
      state.show = false;
      state.rootClose = true;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    }
  }
});

export const { showConfirm, closeConfirm, setLoading } = confirmSlice.actions;
export default confirmSlice.reducer;